import { onUnmounted, watch } from 'vue';

// Invalidate in-flight results as soon as a filter changes, including during the debounce.
export function useAutomaticSearch(filters, search, delay = 300) {
  let timer;
  let requestId = 0;

  watch(filters, () => {
    requestId += 1;
    clearTimeout(timer);
    timer = setTimeout(search, delay);
  });

  onUnmounted(() => {
    clearTimeout(timer);
    requestId += 1;
  });

  return {
    beginRequest: () => ++requestId,
    isCurrentRequest: (id) => id === requestId,
  };
}
